import { render, staticRenderFns } from "./GamePopup.vue?vue&type=template&id=37c02bd4&scoped=true"
import script from "./GamePopup.vue?vue&type=script&lang=js"
export * from "./GamePopup.vue?vue&type=script&lang=js"
import style0 from "./GamePopup.vue?vue&type=style&index=0&id=37c02bd4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c02bd4",
  null
  
)

export default component.exports